import { hotelHasV2Entry } from "../config/pageRegistry";

export function parseHotelFeatureNames(subData) {
  const rows = subData?.subscription || subData?.features || subData?.subscriptions || [];
  if (!Array.isArray(rows)) return [];
  return rows.map((item) => item.fName).filter(Boolean);
}

/**
 * GreenMiles V1 seul (sans pack V2 : Option Eau / Option Menage / V2-GreenMiles).
 */
export function hasOnlyGreenMilesV1(hotelFeatures) {
  const names = Array.isArray(hotelFeatures) ? hotelFeatures : [];
  return names.includes("GreenMiles") && !hotelHasV2Entry(names);
}

/**
 * Chemin d'accueil hôtel selon les subscriptions actives.
 * V2 si Option Eau, Option Menage ou V2-GreenMiles.
 * Sinon GreenMiles V1 ou LuniShower V1.
 */
export function getDefaultHotelPath(hotelFeatures) {
  const names = Array.isArray(hotelFeatures) ? hotelFeatures : [];

  if (hotelHasV2Entry(names)) {
    return "/hotel/lunishower/v2/dashboard";
  }
  if (names.includes("GreenMiles")) {
    return "/hotel/greenmiles/declined-services";
  }
  if (names.includes("LuniShower")) {
    return "/hotel/lunishower/dashboard";
  }
  return "/user/hotels";
}

/** Routes de l'ancienne interface (LuniShower V1 ou GreenMiles V1). */
export function isV1AppPath(path) {
  if (!path || typeof path !== "string") return false;
  if (path.startsWith("/hotel/greenmiles")) return true;
  return path.startsWith("/hotel/lunishower/") && !path.startsWith("/hotel/lunishower/v2");
}

/** Ancienne interface → V2 si Option Eau, Option Menage ou V2-GreenMiles actifs. */
export function shouldRedirectV1AppToV2(hotelFeatures) {
  const names = Array.isArray(hotelFeatures) ? hotelFeatures : [];
  return hotelHasV2Entry(names);
}

/** @deprecated Utiliser shouldRedirectV1AppToV2 */
export function shouldRedirectLuniShowerV1ToV2(hotelFeatures) {
  return shouldRedirectV1AppToV2(hotelFeatures);
}
